import React from 'react';
import { isEmpty } from 'ramda';
import { VisualStyleFilter } from '../VisualStyleFilter';
import { usePLPParams } from '../../../../hooks/usePLPParams';
import { VisualStyleFilterShapeLayout } from '../VisualStyleFilterShapeLayout';

type Props = {
  categoryName: string | null;
};

export const VisualStyleFilterAllStyles: React.FC<Props> = ({ categoryName }) => {
  const {
    params: { attributes },
    clearFilter
  } = usePLPParams();

  return (
    <VisualStyleFilter
      isSelected={isEmpty(attributes)}
      onClick={() => clearFilter('attributes')}
      name={`All ${categoryName || 'Styles'}`}
    >
      <VisualStyleFilterShapeLayout>View All</VisualStyleFilterShapeLayout>
    </VisualStyleFilter>
  );
};
